import { ReferralCypressAttribute } from '@/modules/referral/constants/ReferralCypressAttribute';
import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';
import { ReferralClientTypeOptionKey } from '@/modules/referral/constants/ReferralClientTypeOptionKey';

export class ReferralClientTypeOption extends Enum {
  key!: string;
  value!: string;
  description?: string;
  iconClass!: string;
  e2eKey!: string;

  static INDIVIDUAL: ReferralClientTypeOption = {
    key: ReferralClientTypeOptionKey.INDIVIDUAL,
    get value() {
      return Lang.t('estate.an-individual');
    },
    get iconClass() {
      return 'cls cls-single-neutral-actions';
    },
    get e2eKey() {
      return ReferralCypressAttribute.form.buttons.INDIVIDUAL;
    }
  };

  static COUPLES: ReferralClientTypeOption = {
    key: ReferralClientTypeOptionKey.COUPLES,
    get value() {
      return Lang.t('estate.a-couple');
    },
    get description(): string {
      return Lang.t('estate.a-couple-online-will-digital-vault-unavailable');
    },
    get iconClass() {
      return 'cls cls-contacts';
    },
    get e2eKey() {
      return ReferralCypressAttribute.form.buttons.COUPLES;
    }
  };
}
